import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledLabelFieldDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const CopyButton = styled(Button)`
    margin-left: 12px;
`;

interface ConsumerKeyProps {
    consumerKey: string;
}
const ConsumerKeyDiv = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: flex-end;
`;

const ConsumerKey: React.FC<ConsumerKeyProps> = ({ consumerKey }) => {
    const { t } = useTranslation('admin_settings');

    const copyConsumerKey = () => {
        navigator.clipboard.writeText(consumerKey);
    };
    return (
        <ConsumerKeyDiv>
            <StyledLabelFieldDiv>
                <Typography>{t('consumer-key')}</Typography>
                <Typography variant="body2">{consumerKey}</Typography>
            </StyledLabelFieldDiv>
            <CopyButton variant='outlined' onClick={copyConsumerKey}>{t('copy')}</CopyButton>
        </ConsumerKeyDiv>
    );
};

export default ConsumerKey;
